import React from 'react';
import { Heading, Text } from 'components/Typography';
import { LinkProps } from './types';

export function extractProps<As extends React.ElementType = 'a'>(
  props: LinkProps<As>,
) {
  const {
    autoFocus,
    onBlur,
    onFocus,
    onFocusChange,
    onKeyDown,
    onKeyUp,
    onPress,
    onPressStart,
    onPressEnd,
    onPressChange,
    onPressUp,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    'aria-details': ariaDetails,
    ...rest
  } = props;

  return {
    ariaLinkProps: {
      // PressEvents
      onPress,
      onPressStart,
      onPressEnd,
      onPressChange,
      onPressUp,
    },
    componentProps: rest,
  };
}

export function getTypographyComponent<As extends React.ElementType = 'a'>(
  props: LinkProps<As>,
) {
  if (props.typography === 'heading') {
    return Heading;
  }

  if (props.typography === 'text') {
    return Text;
  }

  return undefined;
}
